/**
 * Avatar desenhado da pessoa pelo sexo e pela idade (mulher, homem, bebê),
 * usado na ficha e no atendimento. Sem sexo informado não há desenho certo:
 * quem chama mostra as iniciais.
 */
import AvatarBabyMale from '../assets/images/avatars/baby_m.png';
import AvatarBabyFemale from '../assets/images/avatars/baby_f.png';
import AvatarAdultMale from '../assets/images/avatars/adult_m.png';
import AvatarAdultFemale from '../assets/images/avatars/adult_f.png';

/** Até esta idade (meses completos, exclusivo) a pessoa usa o avatar de bebê. */
export const BABY_AGE_LIMIT_MONTHS = 24;

/**
 * Meses completos desde o nascimento ("AAAA-MM-DD"). null quando vazio,
 * inválido ou no futuro.
 */
export function getAgeInMonths(birthday) {
  if (!birthday || typeof birthday !== 'string') return null;
  const [year, month, day] = birthday.substring(0, 10).split('-').map(Number);
  if (!year || !month || !day) return null;

  const now = new Date();
  const birth = new Date(year, month - 1, day);
  if (isNaN(birth.getTime()) || birth > now) return null;

  let months = (now.getFullYear() - year) * 12 + (now.getMonth() - (month - 1));
  if (now.getDate() < day) months--;
  return Math.max(0, months);
}

/** "0" masculino, "1" feminino (PatientConfig.Genders); outro valor: sem desenho. */
export function hasDrawableGender(gender) {
  return String(gender) === '0' || String(gender) === '1';
}

/**
 * Imagem do avatar ou null quando o sexo não foi informado.
 * Sem nascimento, usa o avatar adulto.
 */
export function getPatientAvatar(gender, birthday) {
  if (!hasDrawableGender(gender)) return null;
  const male = String(gender) === '0';
  const months = getAgeInMonths(birthday);
  const isBaby = months !== null && months < BABY_AGE_LIMIT_MONTHS;
  if (isBaby) return male ? AvatarBabyMale : AvatarBabyFemale;
  return male ? AvatarAdultMale : AvatarAdultFemale;
}
